import type Cue from 'bundles/interactive-transcript/models/Cue';
import type { LanguageCode } from 'bundles/interactive-transcript/types';

class Track {
  declare cues: Array<Cue>;

  declare languageCode: LanguageCode;

  declare url: string;

  declare sourceContent: $TSFixMe;

  declare isLoaded: boolean;

  constructor(languageCode: LanguageCode, label: $TSFixMe, url: $TSFixMe) {
    this.languageCode = languageCode;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'label' does not exist on type 'Track'.
    this.label = label;
    this.url = url;

    this.sourceContent = null;
    this.cues = [];

    this.isLoaded = false;
  }

  getTextTranscript() {
    return this.cues.map((cue) => cue.text).join(' ');
  }
}

export default Track;
